import {
  SET_CATEGORY_NAME,
  CATEGORY_FORM_REQUEST,
  CATEGORY_FORM_ERROR,
  CATEGORY_FORM_SUCCESS
} from '../actions/categoryForm';

export const categoryForm = (
  state = {
    name: '',
    showForm: false,
    loading: false,
  },
  action
) => {
  switch (action.type) {
    case SET_CATEGORY_NAME: {
      return Object.assign({}, state, { name: action.value });
    }
    case CATEGORY_FORM_REQUEST: {
      return Object.assign({}, state, { loading: true, error: false });
    }
    case CATEGORY_FORM_ERROR: {
      return Object.assign({}, state, { loading: false, error: true });
    }
    case CATEGORY_FORM_SUCCESS: {
      return Object.assign({}, state, { loading: false, error: false });
    }

    default: {
      return state;
    }
  }
};
